import {
	insertDataToTicket,
	hammerEventsHandler,
	setObjectToSessionStorage,
	getObjectFromSessionStorage,
	viewPromoButton,
	wordEnding,
	getZonePropertiesById,
	getRequest,
} from './utils.js';

const $ = window.jQuery;
const { svgPanZoom } = window;
const { prices } = window;
const { uniquePrices } = window;
const svg = $('.js-svg');
const eventId = svg.data('id') || $('#js-subscription-main').data('event');
const unitId = svg.data('unit');
const csrfToken = $("meta[name='csrf-token']").attr('content');
const isDesktop = window.matchMedia('(min-width: 768px)');
const placesPricesDom = $('.js-places-prices');
const storageArr = [];
let word = null;
let isPlaces = true;
let placesPrices = [];
let previousHtml;
let panZoom;

const eventObject = {
	init() {
		eventObject.setUpListeners();
		if (!window.location.pathname.includes('subscription')) {
			eventObject.getCartCount(eventId);
		}

			document.addEventListener('DOMContentLoaded', () => {
				if (svg.length) {
					eventObject.setTagsToSectorPlaces();
					eventObject.addActionToPlace();

					if (isDesktop.matches) {
						eventObject.setPanZoom();
						if (isPlaces) {
							$('.places__prices').show();
							$('.places__info').show();
						} else {
							eventObject.addActionToSector();
						}
						eventObject.getPrices();
					} else if (!isPlaces) {
						eventObject.addActionToSector();
					}
				}
			})
	},
	setPanZoom: () => {
		const svgElement = document.querySelector('#svg-wrap svg');
		if (!$(svgElement).parents('.places').is(':visible')) {
			return false;
		}
		let isEnableZoom = true;

		if (isDesktop.matches) {
			isEnableZoom = false;
		}

		panZoom = svgPanZoom(svgElement, {
			zoomEnabled: true,
			mouseWheelZoomEnabled: isEnableZoom,
			dblClickZoomEnabled: false,
			customEventsHandler: hammerEventsHandler,
		});
		panZoom.fit();

		if (isDesktop.matches) {
			panZoom.zoom(0.75);
		} else {
			panZoom.zoom(0.95);
		}

		panZoom.center();

		$('.js-svg-plan-zoom-in').on('click', () => {
			panZoom.zoomIn();
		});

		$('.js-svg-plan-zoom-out').on('click', () => {
			panZoom.zoomOut();
		});

		$('.js-svg-plan-reset').on('click', () => {
			panZoom.resetZoom();
			panZoom.resetPan();
			panZoom.zoom(0.75);
		});

		$(window).resize(() => {
			panZoom.resize();
			panZoom.fit();
			panZoom.zoom(0.75);
			panZoom.center();
		});

		return false;
	},

	getCartCount: (event_id = 0) => {
		const cartCount = $('.js-count');
		const url = '/event/cart/get-cart';
		$.ajax({
			url,
			data: { '_csrf-frontend': csrfToken, event_id },
			type: 'POST',
			success: (response) => {
				const res = JSON.parse(response);
				if (res.length) {
					cartCount.text(res.length).show();
					$('#js-bottom-pane').show();
				} else {
					cartCount.hide();
				}
				let countTickets = 0;
				$.each(res, (index, order) => {
					countTickets += order.count_tickets;
				});
				$('.js-count').text(countTickets);

				$.each(res, (index, elem) => {
					let summ = 0;
					for (let i = 0; i < elem.carts.length; i++) {
						console.log(elem.carts[i])
						if (elem.carts[i].event_id === event_id) {
							summ += elem.carts[i].price;
						}
					}
					console.log(summ);
					const orderItem = $(`.js-order[data-id="${elem.id}"]`);
					$("#js-event-sum").text(summ);
					orderItem.find('.js-sum').text(elem.amount);
					if (elem.default_amount === elem.amount) {
						orderItem.find('.js-order-discount').hide();
					}
				});
			},
			error: (error) => {
				console.error('Error ', error);
			},
		});
	},

	setActiveTickets: () => {
		const ticketsItems = $('.tickets__item');
		$.each(ticketsItems, (index, element) => {
			const place = $(element).data('place');
			const isPack = $(element).data('ispack');
			if (place && !isPack) {
				$(`#${place}`).addClass('in-cart active');
				$(`#${place}`).data('available', 'false');
			}
			if (isPack) {
				$(`#${place}`).data('ispack', 'true');
			}
		});
	},

	setUpListeners: () => {
		$(document).on('click', '.js-promo .promo__button', (e) => {
			const element = $(e.target);
			const orderId = element.parents('.js-promo').data('order');
			const code = element.parents('.js-promo').find('.promo__input').val();
			eventObject.setPromocode(orderId, code);
		});

		$(document).on("click", ".js-order-pushkin", (e) => {
			e.preventDefault();
			const $currentButton = $(e.currentTarget);
			const pushkinUrl = $currentButton.data("url");
			$("#pushkinModal").modal('show');
			$(".pushkin-modal__close").on("click", () => {
			  $("#pushkinModal").modal("hide");
			});
			$("#pushkinModal").find(".pushkin-modal__confirm").attr("href", pushkinUrl);
		  });

		$(document).on('click', '.js-places-open', (e) => {
			const element = $(e.currentTarget);
			const tickets = element.parents('.places').find('.js-tickets');
			const promo = element.parents('.places').find('.js-promo');
			tickets.slideToggle('slow');
			$(promo).show();
			element.toggleClass('active');
		});

		$(document).on('click', '.js-tickets-remove', (e) => {
			const element = $(e.currentTarget);
			const sid = element.parents('.tickets__item').data('place');
			const elementEventId = element.parents('.tickets__item').data('event');

			if (location.href.includes('event')) {
				eventObject.removeFromCart(sid, elementEventId);
				$(`#${sid}`).data('available', 'true');
				return;
			}

			if (location.href.includes('cart')) {
				const orderId = element.parents('.js-order').data('id');
				eventObject.removeFromCart(sid, elementEventId);
				eventObject.updateAcquirings(orderId);
				if ($('.js-tickets-items').length === 0) {
					window.location.reload();
				}
			}
		});

		$(document).on('click', '#js-order-clear', () => {
			$.ajax({
				url: '/order/cancel-all',
				type: 'POST',
				success: () => {
					window.location.reload();
				},
			});
		});

		$('.js-mobile-buy').on('click', (e) => {
			if (!isDesktop.matches) {
				e.preventDefault();
				eventObject.getPopup();
			}
		});

		if (window.location.pathname.includes('event') && !isDesktop.matches) {
			eventObject.getPopup();
		}

		$('.js-order-cancel').on('click', (e) => {
			const element = $(e.currentTarget);
			const id = element.data('order');
			$.ajax({
				url: `/order/cancel?id=${id}`,
				type: 'POST',
				success: (response) => {
					const res = JSON.parse(response);
					if (res.error === 0) {
						location.reload();
					}
				},
			});
		});

		$('.js-booking-delete').on('click', (e) => {
			const close = $(e.currentTarget);
			const booking = close.parents('.bookings__item');
			const order = $(booking).parents('.js-order');
			const event_id = booking.data('eventId');
			const sub_event_id = booking.data('subEventId');
			$.ajax({
				url: `/subscription-cart/remove-event-sids/${event_id}/${sub_event_id}`,
				type: 'POST',
				success: (res) => {
					const response = JSON.parse(res);
					if (response.result) {
						booking.remove();
						const count = $('.js-count');
						count.text(Number(count.text()) - 1);
						const ordersCount = $('.js-order').length;

						if (Number(count.text()) === 0) {
							if (ordersCount > 1) {
								order.remove();
							} else {
								window.location.reload();
							}
						}

						eventObject.getCartCount(event_id);
					}
				},
			});
		});

		$('.js-bookings-open').on('click', (e) => {
			const element = $(e.currentTarget);
			element.toggleClass('active');
			const bookingsWrapper = element.parents('.bookings').find('.js-bookings-wrapper');
			bookingsWrapper.slideToggle();
		});

		$('.js-places-button').on('click', (e) => {
			const element = $(e.currentTarget);
			$('.js-places-button').removeClass('active');
			element.addClass('active');
		});

		$(document).on('click', '#js-event-date', (e) => {
			const button = $(e.currentTarget);
			button.toggleClass('active');
			$('#js-event-dropdown').toggleClass('active');
		});

		$(document).on('click', '.places__close', () => {
			window.location.assign('/');
		});

		$(document).on('click', '.js-places-back', (e) => {
			const element = $(e.currentTarget);
			element.hide();
			$('.js-change-svg').html(previousHtml);
			eventObject.setTagsToSectors();
			eventObject.getPrices();
			placesPricesDom.hide();
			panZoom.destroy();
			setTimeout(eventObject.setPanZoom, 200);
			isPlaces = false;
		});
	},

	setTagsToSectors: (pricesCurrent) => {
		placesPrices = [];
		$.each(pricesCurrent, (index, element) => {
			const { id } = element;
			const { name } = element;
			const zone = element.z;
			const zoneParams = eventObject.getZonePropertiesById(zone, pricesCurrent.zones);
			const { price } = zoneParams;
			const { color } = zoneParams;
			const selector = $(`#${id}`);
			selector.data('available', 'true');
			selector.data('name', name);
			selector.attr('data-zone', zone);
			selector.data('price', price);
			placesPrices.push(`price:${price},color:${color},zone:${zone}`);
			selector.find('rect').css('fill', color);
			selector.find('ellipse').css('fill', color);
			selector.find('circle').css('fill', color);
			selector.addClass('active');
		});
		const elements = $('.js-svg g[mode]');

		$.each(elements, (index, element) => {
			if (!$(element).hasClass('active')) {
				if (Number($(element).attr('mode')) !== 1) {
					$(element).addClass('disabled');
				}
				if (Number($(element).attr('mode')) === 2) {
					if (!isPlaces) {
						$(element).addClass('active');
					}
				}
			}
		});
	},

	setTagsToSectorPlaces: () => {
		const sectors = svg.find('g');
		isPlaces = true;
		$.each(sectors, (index, sector) => {
			if (Number($(sector).attr('mode')) === 1) {
				isPlaces = false;
				$(sector).data('available', 'true');
				$(sector).attr('view', $(sector).attr('view_id'));
				$(sector).attr('sector-name', $(sector).attr('view_id'));
				$(sector).attr('sector-id', $(sector).attr('view_id'));
				$(sector).attr('all', $(sector).attr('count'));
				$(sector).attr('data-type', 'standart');
			}
		});
	},

	setPromocode: (order_id, code) => {
		$.ajax({
			url: '/promo/apply',
			data: { order_id, code },
			type: 'POST',
			beforeSend: () => {
				$('#js-overlay').show();
			},
			success: (response) => {
				const res = JSON.parse(response);
				const parent = $(`.js-promo[data-order=${order_id}]`).closest('.js-order');
				if (res.status) {
					parent.find('.js-promo').find('.promo__button').addClass('success').text('Успешно');
					parent.find('.js-order-discount').show();

					parent.find('.js-summ').html(res.summ);
					parent.find('.js-promo-discount').html(res.discount);
					parent.find('.promo__button').attr('disabled', 'true');
					parent.find('.js-promo').find('.promo__message').hide();
					parent.find('.promo__input').val(code).attr('disabled', true);

					res.carts.forEach((cart) => {
						const element = $(`.tickets__item[data-place="${cart.sid}"]`);
						element.find(".js-ticket-price").text(cart.price);
					});
				} else {
					const message = res.msg;
					parent.find('.js-promo').find('.promo__message').addClass('error').text(message);
				}
			},
			complete: () => {
				$('#js-overlay').hide();
			},
			error: (error) => {
				console.error('Error ', error);
			},
		});
	},

	getPrices: (view_id = 0) => {
		$.ajax({
			url: '/event/get-prices',
			data: { event_id: eventId, view_id, '_csrf-frontend': csrfToken },
			type: 'POST',
			beforeSend: () => {
				$('#js-overlay').show();
			},
			success: (response) => {
				const res = JSON.parse(response);
				eventObject.addActionToPrice();
				for (let i = 0; i < res.prices.length; i++) {
					const elem = res.prices[i];
					const { id } = elem;
					const zoneId = elem.z;
					const zone = getZonePropertiesById(zoneId, res.zones);
					const elemDom = $(`#${id}`);
					const { color } = zone;
					elemDom.addClass('active');
					elemDom.find('rect').css('fill', color);
					elemDom.find('ellipse').css('fill', color);
					elemDom.find('circle').css('fill', color);
					elemDom.data('ispack', 'true');
					elemDom.attr('data-zone', zoneId);
					elemDom.data('color', color);
					elemDom.data('available', 'true');
				}
				const { clientWidth } = document.documentElement;
				if (!res.prices.length && clientWidth > 767) {
					$('.transparent-overlay').show();
				}
				if (!res.prices.length && clientWidth < 767) {
					$('.transparent-overlay-mobile').show();
				}

				eventObject.setActiveTickets();
			},
			error: (error) => {
				console.error('Error ', error);
			},
			complete: () => {
				$('.js-places-change').addClass('active');
				$('#js-overlay').hide();
			},
		});
	},

	getSectorSvg: (viewId) => {
		$.ajax({
			url: '/event/get-svg',
			data: { event_id: eventId, view_id: viewId, '_csrf-frontend': csrfToken },
			type: 'POST',
			beforeSend: () => {
				$('#js-overlay').show();
			},
			success: (response) => {
				const res = JSON.parse(response);
				$('.js-change-svg').html(res.svg);
				eventObject.getPrices(viewId);
				eventObject.setPanZoom();
				$('.places__prices').show();
				localStorage.setItem(`${unitId}_${viewId}`, res.svg);
			},
			complete: () => {
				$('#js-overlay').hide();
			},
			error: (error) => {
				console.error('Error ', error);
			},
		});
	},

	getFastRegistration: () => {
		$('#fastRegisterModal').detach().appendTo('body');
		$('#fastRegisterModal').modal();
	},

	getPopup: () => {
		if (!$('.places__content').length) {
			return false;
		}
		const content = $('.places__content')[0].outerHTML;
		$('#js-popup-modal .modal-body').html(`<div class="places">${content}</div>`);
		$('#js-popup-modal .places').show();
		$('.places__top').show();
		if (isPlaces) {
			$('.places__prices').show();
			$('.places__info').show();
		}
		$('.modal-body .places__top').after($('.modal-body .places__legend'));
		$('.modal-body .places__top').after($('.modal-body .places__info'));
		$('.modal-body .places__top').after($('.modal-body .places__prices'));
		$('.modal-body .places__name').after($('.events__dates'));
		$('.modal-body .places__cart').append($('.modal-body .js-promo'));
		$('.modal-body .places__cart').prepend($('.modal-body .places__legend'));
		$('.modal-body .places__cart').append($('.modal-body .js-event-places-right'));
		$('.modal-body .js-event-places-right').removeClass('hide');
		$('.js-tickets').hide();
		$('#js-popup-modal').modal();
		viewPromoButton();
		setTimeout(eventObject.setPanZoom, 200);
		setTimeout(eventObject.getPrices, 200);
		setTimeout(eventObject.setActiveTickets, 200);
	},

	addToCart: (sid, price_view_id, clickedElement) => {
		$.ajax({
			url: '/event/cart/add',
			data: { event_id: eventId, sid, price_view_id, '_csrf-frontend': csrfToken },
			type: 'POST',
			beforeSend: () => {
				$('#js-overlay').show();
			},
			success: (response) => {
				const res = JSON.parse(response);
				if (res.carts) {
					let parentElement;
					let eventCount = 0;
					let eventSum = 0;
					ym(75020935, 'reachGoal', 'basket');
					const ticketItems = $('#js-tickets-items');
					ticketItems.html('');
					const { carts } = res.order;

					for (let i = 0; i < carts.length; i++) {
						const item = carts[i];
						const isPack = carts[i].is_pack;
						const isCurrentCart = i + 1 === carts.length;

						if (isPack) {
							if (isCurrentCart) {
								$(clickedElement).addClass('js-packed-plan');
							}

							$(`#${item.sid}`).data('ispack', true);
							$(clickedElement).removeClass('in-cart');
						} else {
							$(`#${item.sid}`).addClass('in-cart');
						}

						if (item.event_id === eventId) {
							eventCount++;
							eventSum += item.price;
						}

						$('.js-count-event').text(eventCount);
						console.log('add');
						$('#js-event-sum').text(eventSum);
						const order = $(`.js-order[data-event="${eventId}"]`);
						const ticket = insertDataToTicket(item, isPack);

						if (!$('.js-promo').data('promocode')) {
							order.find('.js-sum').text(res.order.amount);
						}
						if (item.event_id === eventId) {
							ticketItems.append(ticket);
							console.log(eventId);
						}
						parentElement = $(`.js-order[data-event="${res.order.carts[i].event_id}"]`);
					}

					$('#js-bottom-pane').show();
					$('.js-count').each((index, element) => {
						$(element).text(Number($(element).text()) + 1);
					});
					word = $('.places__count-word');
					word.text(wordEnding(res.order.count_tickets, ['билет', 'билета', 'билетов']));
					$('.js-count-word').text(
						wordEnding(res.order.count_tickets, ['билет', 'билета', 'билетов'])
					);
					$('.js-event-places-right').removeAttr('style').removeClass('hide');
					$('.js-promo').show();

					$('.places__change').addClass('short');
					$('.order').removeClass('short');
					$('.js-places-selected').text(res.order.count_tickets);
					$('.places__cost').addClass('show');

					const code = parentElement.find('.js-promo').data('promocode');
					const orderId = parentElement.find('.js-promo').data('order');

					if (code) {
						eventObject.setPromocode(orderId, code);
					}

					const zone = $(`#${sid}`).data('zone');
					const storageObject = { sid, zone };
					const getStorage = getObjectFromSessionStorage(eventId);
					if (getStorage) {
						getStorage.push(storageObject);
						setObjectToSessionStorage(eventId, getStorage);
					} else {
						storageArr.push(storageObject);
						setObjectToSessionStorage(eventId, storageArr);
					}
				}

				if (res.redraw) {
					$(`#${sid}`).addClass('in-cart');
					window.location.reload();
				}

				if (res.limit) {
					alert('Вы превысили максимально допустимое количество мест для брони');
				} else {
					for (let i = 0; i < res.carts.length; i++) {
						const item = res.carts[i];
						const isPack = res.carts[i].is_pack;
						if (!isPack) {
							$(`#${item.sid}`).addClass('in-cart');
						}
					}
					eventObject.getCartCount(eventId);
				}
			},
			complete: () => {
				if (!$('.js-promo').data('promocode')) {
					$('#js-overlay').hide();
				}
			},
			error: (error) => {
				console.error('Error ', error);
			},
		});
	},

	removeFromCart: (sid, event_id = eventId) => {
		$.ajax({
			url: '/event/cart/remove',
			data: { event_id, sid, '_csrf-frontend': csrfToken },
			type: 'DELETE',
			beforeSend: () => {
				$('#js-overlay').show();
			},
			success: (response) => {
				const res = JSON.parse(response);
				if (response.error) {
					window.location.reload();
				}
				if (res.redraw) {
					alert('Данное место больше недоступно. Выберите другое. ');
				}
				let order;
				const { carts } = res;
				const orderSubEvent = $(`.order__sub-event[data-event=${event_id}]`);
				const $eventSum = orderSubEvent.find('.js-order-event-sum');
				if (carts.length >= 1) {
					for (let i = 0; i < carts.length; i++) {
						const currentSid = carts[i].sid;
						const currentUid = carts[i].uid;
						$(`#${currentSid}`).removeClass('in-cart');
						const $item = $(`.tickets__item[data-uid='${currentUid}']`);
						const price = Number($item.find('.js-ticket-price').text());
						const sum = parseFloat($eventSum.text()) - price;
						if (sum === 0) {
							window.location.reload();
						}
						$eventSum.text(sum);
						$item.remove();
					}
					if (res.active_carts[event_id]) {
						console.log('remove');
						$('#js-event-sum').text(res.active_carts[event_id].summ);
						$('.js-summ').text(res.summ);
					} else {
						$('#js-bottom-pane').hide();
					}
				} else {
					const { uid } = carts[0];
					order = $(`.tickets__item[data-uid="${uid}"]`).parents('.js-order');
					const $item = $(`.tickets__item[data-uid='${uid}']`);
					const price = Number($item.find('.js-ticket-price').text());
					const sum = parseFloat($eventSum.text()) - price;
					if (sum === 0) {
						window.location.reload();
					}
					$eventSum.text(sum);
					$item.remove();
					$(`#${sid}`).removeClass('in-cart');
					order.find('.js-summ').text(res.summ);
				}
				const orderInfoCount = $(`.js-order-type[data-type="ordinary"] .order__info-count`);
				orderInfoCount.text(Number(orderInfoCount.text()) - 1);
				$('.js-count').each((index, el) => {
					$(el).text(res.count);
				});
				word = $('.js-count-word');
				if (word) {
					word.text(wordEnding(res.count, ['билет', 'билета', 'билетов']));
				}
				$('.js-places-selected').text(res.count);
				eventObject.getCartCount(eventId);
				$('.promo__discount').removeClass('active');
				$('.js-promo-discount').text(res.discount);

				$('.js-count-event').text(res.count);
				if ($('.lk').length && !$('.js-tickets-items').children().length > 0) {
					if ($('.js-order').length > 1) {
						order.remove();
					} else {
						window.location.reload();
					}
				}
				if (!$('.js-tickets-items').children().length > 0) {
					$('.js-event-places-right').addClass('hide');
					$('.places__cost').addClass('hide').removeClass('show');
					$('.modal-body .js-promo').hide();
					$('.places__common').removeClass('active').addClass('short');
					$('.places__svg').removeClass('short').addClass('long');
				}
				const getStorage = getObjectFromSessionStorage(event_id);
				for (let i = 0; i < getStorage.length; i++) {
					if (getStorage[i].sid === sid) {
						const { zone } = getStorage[i];
						const color = $(`.places__input[data-zone="${zone}"]`).data('color');
						$(`#${sid}`).removeClass('disabled');
						$(`#${sid}`).find('rect').css('fill', color);
						$(`#${sid}`).find('ellipse').css('fill', color);
						$(`#${sid}`).find('circle').css('fill', color);
						getStorage.splice(i, 1);
					}
				}
				setObjectToSessionStorage(event_id, getStorage);
			},
			complete: () => {
				$('#js-overlay').hide();
			},
			error: (error) => {
				console.error('Error ', error);
			},
		});
	},
	/**
	 * Получает вид цены
	 * @param {Number} zone
	 * @return {String}
	 */
	getPriceViewIdByZone(zone) {
		if (!zone) return null;
		const priceObject = prices.filter((element) => element.zone === zone);

		return priceObject.length > 0 ? priceObject[0].priceViewId : null;
	},

	addActionToPlace: () => {
		$(document).on('click', (e) => {
			const element = e.target;
			if ($(element).closest('g.active').length) {
				const activeSector = $(element).closest('g.active');

				const sid = $(activeSector).attr('id');
				const priceViewId = eventObject.getPriceViewIdByZone(
					Number($(activeSector).attr('data-zone'))
				);

				const isPackedPlan = $(activeSector).hasClass('js-packed-plan') || false;

				if (isPackedPlan) {
					eventObject.addToCart(sid, priceViewId);
				} else {
					const isCart = $(activeSector).data('available');

					if (isCart === 'true') {
						$(activeSector).data('available', 'false');
						eventObject.addToCart(sid, priceViewId, activeSector);
					} else if (isCart === 'false') {
						$(activeSector).data('available', 'true');
						eventObject.removeFromCart(sid);
					}
				}
			}
		});
		if (isDesktop.matches) {
			$(document).on('mouseover', (e) => {
				const element = $(e.target);
				if (element.closest('g.active').length) {
					const activeSector = $(element).closest('g.active');
					const name = activeSector.data('name');
					const price = activeSector.data('price');
					eventObject.addTooltipToPlace(activeSector, price, name);
				} else {
					$('.tooltip-info').hide();
				}
				if (element.closest('g[view_id]').length) {
					const activeSector = $(element).closest('g[view_id]');
					let name = activeSector.find('text').text();
					if (!name) {
						name = activeSector.next().text();
					}
					const price = activeSector.attr('price');
					const count = activeSector.attr('count');
					const free = activeSector.attr('free');

					eventObject.addTooltipToSector(activeSector, price, count, free, name);
				}
			});
		}
	},

	addActionToPrice: () => {
		$('.places__price input').change((e) => {
			const input = $(e.currentTarget);

			if (input.is(':checked')) {
				const color = !isDesktop.matches ? '#000' : input.data('color');
				input.next().css('border-color', color);
			} else {
				input.next().css('border-color', '');
			}

			if ($('.places__price input:checked').length === 0) {
				eventObject.resetPrice();
				$('.places__price-reset').hide();
			} else {
				$('.places__price-reset').show();
				$('g').each((_, elem) => {
					const el = $(elem);
					const zonePlace = el.data('zone');

					if (zonePlace) {
						const isChoosedPrice = !!$(`input[data-zone="${zonePlace}"]`).is(':checked');

						if (isChoosedPrice) {
							el.removeClass('gray');
							el.addClass('active');
						}

						if (!isChoosedPrice && el.hasClass('active')) {
							el.addClass('gray');
							el.removeClass('active');
						}
					}
				});
			}
		});
		$('.places__price').hover(
			(e) => {
				const color = $(e.currentTarget).find('.places__price-color').css('background-color');
				$(e.currentTarget).find('.places__price-content').css('border-color', color);
			},
			(e) => {
				const input = $(e.currentTarget).find('input');
				if (input.is(':checked')) {
					$(e.currentTarget)
						.find('.places__price-content')
						.css('border-color', input.data('color'));
				} else {
					$(e.currentTarget).find('.places__price-content').css('border-color', '');
				}
			}
		);

		$('.places__price').on('click', (e) => {
			const element = $(e.currentTarget);
			if (element.find('.places__price-content').css('border-color') !== 'transparent') {
				element.find('.places__price-content').css('border-color', 'transparent');
			}
		});

		$('.places__price-reset').on('click', (e) => {
			$('.places__price input').each((_, elem) => {
				elem.checked = false;
			});

			eventObject.resetPrice();
			$('.places__price-content').css('border-color', '');
			$(e.target).hide();
		});
	},

	resetPrice: () => {
		$('g').each((_, elem) => {
			const el = $(elem);
			if (el.hasClass('gray')) {
				el.removeClass('gray');
				el.addClass('active');
			}
		});
	},

	addActionToPriceSector: () => {
		$('.places__price input').change((e) => {
			const input = $(e.currentTarget);
			if (input.is(':checked')) {
				input.next().css('border-color', '#e01115');
			} else {
				input.next().css('border-color', 'transparent');
			}
			if ($('.places__price input:checked').length === 0) {
				$('g[view_id]').removeClass('inactive');
			} else {
				$('g[view_id]').each((i, elem) => {
					const el = $(elem);
					const myPriceStr = String(el.attr('price'));
					if (myPriceStr) {
						const myPrice = myPriceStr.split(',');
						let hideFlag = 0;

						for (let j = 0; j < myPrice.length; j++) {
							if (!$(`input[data-price="${parseInt(myPrice[j])}"]`).is(':checked')) {
								hideFlag++;
							}
						}
						if (hideFlag === myPrice.length) {
							el.addClass('inactive');
						} else {
							el.removeClass('inactive');
						}
					}
				});
			}
		});
	},
	addPricesToSector: () => {
		for (let i = 0; i < prices.length; i++) {
			const item = prices[i];
			const { viewId } = item;
			const { price } = item;
			const element = $(`g[view_id='${viewId}'`);
			if (!element.attr('price')) {
				element.attr('price', price);
			} else {
				let strPrice = element.attr('price');
				strPrice += `,${price}`;
				element.attr('price', strPrice);
			}
		}
	},

	addPricesPlacesToSector: () => {
		for (const prop in uniquePrices) {
			if (Object.prototype.hasOwnProperty.call(uniquePrices, prop)) {
				if (uniquePrices[prop] !== null) {
					placesPrices.push(Number(uniquePrices[prop]));
				}
			}
		}

		placesPricesDom.html('');
		placesPrices = placesPrices.sort((a, b) => {
			return a - b;
		});
		for (let i = 0; i < placesPrices.length; i++) {
			const item = placesPrices[i];
			const placesPrice = `<label class="places__price">
<input class="places__input" type="checkbox" data-price="${item}">
<span class="places__price-content">
<span>${item} руб.</span></span>
</label>`;
			placesPricesDom.append(placesPrice);
		}
		placesPricesDom.addClass('places__prices_sector');
		placesPricesDom.show();
	},

	addActionToSector: () => {
		$('.js-places-change').addClass('active');
		previousHtml = $('.js-change-svg').html();
		$(document).on('click', (e) => {
			const element = e.target;
			if ($(element).closest('g[view]').length) {
				const activeSector = $(element).closest('g[view]');
				const sectorId = activeSector.attr('sector-id');
				const svgLocal = localStorage.getItem(`${unitId}_${sectorId}`);
				if (!svgLocal) {
					eventObject.getSectorSvg(sectorId);
				} else {
					$('.js-change-svg').html(svgLocal);
					eventObject.getPrices(sectorId);
					$('.places__prices').show();
					$('.places__info').show();
				}
				panZoom.destroy();
				setTimeout(eventObject.setPanZoom, 200);
				$('.js-places-back').show();
				isPlaces = true;
			}
		});
	},

	addTooltipToPlace: (activeSector, price, name) => {
		const info = $('.js-seat-info');
		const clientX =
			activeSector[0].getBoundingClientRect().x || activeSector[0].getBoundingClientRect().left;
		const clientY =
			activeSector[0].getBoundingClientRect().y || activeSector[0].getBoundingClientRect().top;
		const y = clientY - info.outerHeight();
		const x = clientX - info.outerWidth() / 2;
		if (price) {
			info.find('.tooltip-info__price').text(`${price} руб.`);
			info.find('.tooltip-info__name').text(name);
			info.css({ left: x, top: y });
			info.show();
		}
	},
	addTooltipToSector: (activeSector, price, count, free, name) => {
		const info = $('.js-sector-info');
		const clientX =
			activeSector[0].getBoundingClientRect().x || activeSector[0].getBoundingClientRect().left;
		const clientY =
			activeSector[0].getBoundingClientRect().y || activeSector[0].getBoundingClientRect().top;
		const y = clientY - info.outerHeight();
		const x = clientX - info.outerWidth() / 2;
		if (price !== undefined) {
			price = price.split(',');
			price = price.sort((a, b) => {
				return a - b;
			});
			price = Array.from(price).map((item) => {
				return ` ${item} руб.`;
			});
			info.find('.tooltip-info__price').text(`Цена ${price}`);
		}

		info.find('.tooltip-info__name').text(`Сектор ${name}`);
		info.find('.tooltip-info__available').text(`Свободно ${free}`);
		info.find('.tooltip-info__count').text(`из ${count}`);
		info.css({ left: x, top: y });
		info.show();
	},

	updateAcquirings(orderId) {
		getRequest(`/order/get-acquirings/${orderId}`).then((res) => {
			$.each(res, (i, acquiringData) => {
				const isDisabled = acquiringData.disabled;
				const { acquiring } = acquiringData;
				const $acquiring = $(`.js-order[data-id=${orderId}]`).find(
					`[data-acquiring-id=${acquiring.id}]`
				);
				if (isDisabled) {
					if (!$acquiring.hasClass('inactive')) $acquiring.addClass('inactive');
				} else if ($acquiring.hasClass('inactive')) {
					window.location.reload();
					$acquiring.removeClass('inactive');
				}
			});
		});
	},
};

export default eventObject;
